import { AbstractControl } from '@angular/forms';

export function fieldsMatchValidator(field: string, matchingField: string) {
  return (form: AbstractControl) => {
    const fieldCtrl = form.get(field);
    const matchingFieldCtrl = form.get(matchingField);
    if (
      matchingFieldCtrl!.errors &&
      !matchingFieldCtrl!.errors['fieldsMissMatch']
    ) {
      return;
    }
    if (fieldCtrl!.value !== matchingFieldCtrl!.value) {
      matchingFieldCtrl!.setErrors({ fieldsMissMatch: true });
    } else {
      matchingFieldCtrl!.setErrors(null);
    }
  };
}
